import { render, staticRenderFns } from "./selectDepartTree.vue?vue&type=template&id=a1d039cc&scoped=true"
import script from "./selectDepartTree.vue?vue&type=script&lang=js"
export * from "./selectDepartTree.vue?vue&type=script&lang=js"
import style0 from "./selectDepartTree.vue?vue&type=style&index=0&id=a1d039cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d039cc",
  null
  
)

export default component.exports